import { render } from "./member_payment.vue?vue&type=template&id=546807b8&scoped=true"
import script from "./member_payment.vue?vue&type=script&lang=js"
export * from "./member_payment.vue?vue&type=script&lang=js"

import "./member_payment.vue?vue&type=style&index=0&id=546807b8&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546807b8"]])

export default __exports__